module.exports = __webpack_public_path__ + "img/1018.07da0645.png";